import React from 'react';
import { Typography, Box } from '@mui/material';



const ParaBullet = (props) => <React.Fragment><ul><li><Typography align='justify' sx={{ fontSize: "16px",  marginTop: "20px" }}>{props.content} </Typography></li></ul></React.Fragment>

export default ParaBullet;


